import { useEffect, useRef } from 'react';
import { Button } from '../../../shared/components/Button';

export default function ZoomRepeatButton({
  icon,
  description,
  descriptionUp = false,
  type = 'tomato',
  disabled,
  onPress,
  onRepeat,
  repeatDelay = 500,
  repeatInterval = 100,
}) {
  const timeoutRef = useRef(null);
  const intervalRef = useRef(null);
  const repeatedRef = useRef(false);
  const disabledRef = useRef(disabled);
  const onPressRef = useRef(onPress);
  const onRepeatRef = useRef(onRepeat);
  disabledRef.current = disabled;
  onPressRef.current = onPress;
  onRepeatRef.current = onRepeat;

  useEffect(() => () => {
    window.clearTimeout(timeoutRef.current);
    window.clearInterval(intervalRef.current);
  }, []);

  useEffect(() => {
    if (!disabled) return;
    window.clearTimeout(timeoutRef.current);
    window.clearInterval(intervalRef.current);
  }, [disabled]);

  const stopRepeating = () => {
    window.clearTimeout(timeoutRef.current);
    window.clearInterval(intervalRef.current);
    timeoutRef.current = null;
    intervalRef.current = null;
  };

  return (
    <span
      style={{ touchAction: 'none' }}
      onPointerDown={(event) => {
        if (disabledRef.current || (event.pointerType !== 'touch' && event.button !== 0)) return;
        stopRepeating();
        repeatedRef.current = false;
        timeoutRef.current = window.setTimeout(() => {
          if (disabledRef.current) return;
          repeatedRef.current = true;
          (onRepeatRef.current || onPressRef.current)();
          intervalRef.current = window.setInterval(() => {
            if (!disabledRef.current) (onRepeatRef.current || onPressRef.current)();
          }, repeatInterval);
        }, repeatDelay);
      }}
      onPointerUp={stopRepeating}
      onPointerCancel={stopRepeating}
      onPointerLeave={stopRepeating}
    >
      <Button
        icon={icon}
        description={description}
        descriptionUp={descriptionUp}
        type={type}
        disabled={disabled}
        onPress={() => {
          if (repeatedRef.current) {
            repeatedRef.current = false;
            return;
          }
          onPressRef.current();
        }}
      />
    </span>
  );
}